import React from 'react';
//import { useState, useReducer, useEffect } from 'react';
import {
  VirtualTableState,
  SortingState,
  // DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';

// import utils from '../utils'
import AuthService from '../services/auth-service'; 
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
// import Badge from '@mui/material/Badge';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

import SoftwareFwListTableProps, { 
  DateTypeProvider, 
  IsBetaTypeProvider, 
  ItemTypeProvider,
  RowNumTypeProvider,
  CounterTypeProvider, 
} from './SoftwareFwListTableProps'

//import AddIcon from '@mui/icons-material/Add';
//import Fab from '@mui/material/Fab';

//import { Autocomplete, Stack, Paper, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import { Paper } from "@mui/material"
//import LinearProgress from '@mui/material/LinearProgress';
//import Slider, { SliderThumb } from '@mui/material/Slider';
//import { styled } from '@mui/material/styles';
//import Typography from '@mui/material/Typography';
//import Tooltip from '@mui/material/Tooltip'; 
//import notify from 'devextreme/ui/notify';

// ************************************************************
// ************************************************************
// ************************************************************

const VIRTUAL_PAGE_SIZE = 50;
const getRowId = row => row.id;

// ************************************************************
// ************************************************************
// ************************************************************

export const SoftwareFwListComponentWrapper = (props) => {
  const { mode, group, selector } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    if (mode) {
      // Perform rest api call and response handling
      console.log("mode!!!")
    }
  }, [mode]);
  return <SoftwareFwList 
    mode={mode} 
    group={group} 
    selector={selector} 
    navigate={navigate} 
    {...props} />
}

class SoftwareFwList extends React.Component {
  constructor(props) {    
    super(props)    
    this.table_props = new SoftwareFwListTableProps()
    this.state = {
      current_mode: "last",
      dialog_open: false,
      dialog_spin: false,
      table_total_row_count_ready: false,
      tableRows: [],
      tableSkip: 0,
      requestedTableSkip: 0,
      requestedTableTake: 0,
      tableTotalRowCount: VIRTUAL_PAGE_SIZE * 2,
      tableLoading: false,
      tableColumns: this.table_props.getTableColumns(),
      tableColumnExtensions: this.table_props.getTableColumnExtensions(),
      tableSortingStateColumnExtensions: this.table_props.getTableSortingStateColumnExtensions(),
      tableFilteringStateColumnExtensions: this.table_props.getTableFilteringStateColumnExtensions(),
      tableColumnWidths: this.table_props.getTableColumnWidths(),
      tableFilters: [],
      tableSorting: [{
        columnName: "created_at",
        direction: "desc",
      }],    
    }
  }
  
  async getTableRows(requestedTableSkip, take) {
    console.log("getTableRows")
    this.setState({ 
      requestedTableSkip: requestedTableSkip,
      requestedTableTake: take,
      tableLoading: true 
    })    
    AuthService.getSoftwareFwList(requestedTableSkip, take, this.state.tableSorting[0], this.state.tableFilters, this.state.current_mode).then(data => {
      var i = requestedTableSkip + 1
      data.rows = data.rows.map(row => {
        row.row_num = i++
        return row
      })
      if (data.is_valid) {
        this.setState({
          tableSkip: data.skip, 
          tableRows: data.rows,
          tableLoading: false,
        })
      } else {
        //console.log(data.message)
        this.setState({ tableLoading: false })
      }
    }).catch(e => {
      //console.log(e)
      this.setState({ tableLoading: false })
    })
  }
  setTableSorting(value) {
    //console.log(value)
    this.setState({
      tableSorting: value
    })
  }
  async setTableFilters(value) {
    //console.log("setTableFilters", value)
    this.setState({ 
      tableFilters: value
    })    
    var data = await AuthService.getSoftwareFwCount(value, this.state.current_mode)
    if (data.is_valid) {
      console.log("tableTotalRowCount", data.value)
      this.setState({
        tableTotalRowCount: data.value,
        table_total_row_count_ready: true,
      })
    }
  }
  setTableColumnWidths(value) {
    console.log(value)
    this.setState({
      tableColumnWidths: value
    })
  }
  async componentDidMount() {
    console.log("mode", this.props.mode) 
    console.log("group", this.props.group) 
    console.log("selector", this.props.selector) 
    await this.setState({ current_mode: this.props.mode })
    var tableFilters = []
    if (this.props.group !== undefined) {
      tableFilters.push({
        columnName: "group",
        value: this.props.group,
        operation: "contains",
      })      
    }
    if (this.props.selector !== undefined) {
      tableFilters.push({
        columnName: "selector",
        value: this.props.selector,
        operation: "contains",
      })      
    }
    await this.setTableFilters(tableFilters)
  }
  async componentDidUpdate() {
    //console.log("did update!")
    if (this.props.mode !== this.state.current_mode)
    {
      //console.log("mode changed")
      //await this.setState({ current_mode: this.props.mode })
      //await this.getTableRows(this.state.requestedTableSkip, this.state.requestedTableTake)
      window.location.reload()
    }
  }

  render() {     
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />        

    if (this.props.authStatus.user.is_admin) {
      // ok
    } else if (this.props.authStatus.user.is_reseller) {
      // ok
    } else {
      return <UserAuthRequired notallowed />
    }

    // aspettiamo che ci sia questa info prima di caricare il resto, altrimenti non mi aggiorna il filtro dei reseller
    if (!this.state.table_total_row_count_ready) return <LoadingSpinner />

    // ***

    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper>
        <Grid 
          rows={this.state.tableRows}
          columns={this.state.tableColumns}
          getRowId={getRowId}
          >
          <RowNumTypeProvider 
            for={[ "row_num" ]} 
            availableFilterOperations={[
              'equal',
            ]}
            />
          <CounterTypeProvider 
            for={[ "counter" ]} 
            availableFilterOperations={[
              'equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'
            ]}
            />
          <DateTypeProvider for={[
            "created_at", "last_download",
          ]} />
          <ItemTypeProvider for={[
            "item",
          ]} />
          <IsBetaTypeProvider 
            for={[ "is_beta" ]}
            availableFilterOperations={[
              'equal',
            ]}
            />
          <SortingState
            sorting={this.state.tableSorting}
            onSortingChange={this.setTableSorting.bind(this)}
            columnExtensions={this.state.tableSortingStateColumnExtensions}
            />
          <VirtualTableState 
            loading={this.state.tableLoading}
            totalRowCount={this.state.tableTotalRowCount} 
            pageSize={VIRTUAL_PAGE_SIZE}
            skip={this.state.tableSkip}
            getRows={this.getTableRows.bind(this)}
            />
          <FilteringState
            filters={this.state.tableFilters}
            onFiltersChange={this.setTableFilters.bind(this)}
            columnExtensions={this.state.tableFilteringStateColumnExtensions}
            />
          <VirtualTable 
            height={height}
            columnExtensions={this.state.tableColumnExtensions} 
            />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={this.setTableColumnWidths.bind(this)}
            />
          <TableHeaderRow 
            showSortingControls
            />
          <TableFilterRow 
            showFilterSelector
            />
        </Grid>
      </Paper>
    )
  }
}
